'use strict'

export const carrousel = (() => {
    const init = () => {
        const carrousels = document.querySelectorAll('.carrousel');

        if (carrousels.length) {
            carrousels.forEach(carrousel => {
                const carrouselContainers = carrousel.querySelectorAll('.carrousel-container')
                const carrouselSelectors = carrousel.querySelectorAll('.carrousel-selector')

                const showContainer = (index) => {
                    carrouselContainers.forEach((storyContainer) => storyContainer.classList.add('hidden'))
                    carrouselContainers[index].classList.remove('hidden')
    
                    carrouselSelectors.forEach((storySelector) =>
                        storySelector.classList.remove('bg-primary')
                    )
                    carrouselSelectors[index].classList.add('bg-primary')
                }
    
                carrouselSelectors.forEach((storySelector, index) => {
                    storySelector.addEventListener('click', () => showContainer(index))
                })
    
                showContainer(0)
                
            });
        }
    }

    return {
        init
    }
})()
